import { decorateEmptyGridValues } from "../../../utils/table/gridUtils";
import {
  FETCH_DASHBOARD_ALL_RESERVATIONS,
  FETCH_DASHBOARD_DETAILS,
  FETCH_DASHBOARD_INIT,
  FETCH_V4_DASHBOARD,
  SET_DASHBOARD_LOCATIONS,
  TOAST,
} from "../../types/dashboard";

const buildColumns = (valueLabel) => {
  const baseExtraProps = {
    isSortable: false,
    isDateField: false,
    shouldFilter: true,
    hidden: false,
    showFilterMenu: false,
    filterPlaceholder: "Search...",
  };

  return [
    {
      colLabel: "Month",
      dataKey: "month",
      extraProps: {
        ...baseExtraProps,
        sortField: "month",
      },
    },
    {
      colLabel: "Category",
      dataKey: "category",
      extraProps: {
        ...baseExtraProps,
        sortField: "category",
      },
    },
    {
      colLabel: valueLabel,
      dataKey: "value",
      extraProps: {
        ...baseExtraProps,
        shouldFilter: false,
        filterPlaceholder: undefined,
        sortField: "value",
      },
    },
  ];
};

const transformToGridView = (nested, valueLabel) => {
  const rows = nested.flatMap((monthArr) =>
    monthArr.map((o) => {
      /* decorate blanks */
      const raw = {
        month: o.month,
        category: o.categoryTitle,
        value: o.inquiries,
      };
      const decorated = {};
      Object.keys(raw).forEach(
        (k) => (decorated[k] = decorateEmptyGridValues(raw[k]))
      );
      return decorated;
    })
  );

  return { columns: buildColumns(valueLabel), rows };
};

const INITIAL_STATE = {
  reservedGrid: { columns: [], rows: [] },
  inquireGrid: { columns: [], rows: [] },

  dashboardData: null,
  isLoading: false,
  isPageLevelError: false,
  error: null,

  isDashboardResSuccess: false,
  isDashboardResError: false,

  v4Data: null,
  selectedLocationIds: [],
};

export const dashboardReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_DASHBOARD_INIT:
      return { ...INITIAL_STATE, isLoadingPage: true };

    case FETCH_DASHBOARD_ALL_RESERVATIONS.START:
    case FETCH_DASHBOARD_DETAILS.START:
      return { ...state, isLoading: true };

    case FETCH_DASHBOARD_ALL_RESERVATIONS.SUCCESS: {
      const { mostReservedCategories, mostInquireCategories } = action.payload;

      const resetState = {
        reservedGrid: { columns: [], rows: [] },
        inquireGrid: { columns: [], rows: [] },
        error: null,
        isLoading: false,
        isPageLevelError: false,
        isDashboardResSuccess: false,
        isDashboardResError: false,
      };

      if (!mostReservedCategories && !mostInquireCategories) {
        return { ...state, ...resetState };
      }

      return {
        ...state,
        ...resetState,
        reservedGrid: transformToGridView(
          mostReservedCategories,
          "Reservations"
        ),
        inquireGrid: transformToGridView(mostInquireCategories, "Inquiries"),
        isDashboardResSuccess: true,
      };
    }

    case FETCH_DASHBOARD_ALL_RESERVATIONS.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        reservedGrid: { columns: [], rows: [] },
        inquireGrid: { columns: [], rows: [] },
        isLoading: false,
        isPageLevelError: true,
        isDashboardResError: true,
        error,
      };
    }

    case FETCH_DASHBOARD_DETAILS.SUCCESS:
      return {
        ...state,
        isLoading: false,
        dashboardData: action.payload,
        isDashboardFetchSuccess: true,
        isDashboardFetchError: false,
        error: null,
      };

    case FETCH_DASHBOARD_DETAILS.ERROR:
      return {
        ...state,
        isLoading: false,
        dashboardData: null,
        isDashboardFetchSuccess: false,
        isDashboardFetchError: true,
        error: action.payload?.error || action.payload,
      };

    case TOAST.RESET:
      return {
        ...state,
        isDashboardResSuccess: false,
        isDashboardResError: false,
      };

    case SET_DASHBOARD_LOCATIONS:
      return { ...state, selectedLocationIds: action.payload };

    case FETCH_V4_DASHBOARD.START:
      return { ...state, isLoading: true };

    case FETCH_V4_DASHBOARD.SUCCESS:
      return {
        ...state,
        isLoading: false,
        v4Data: action.payload,
      };

    case FETCH_V4_DASHBOARD.ERROR:
      return {
        ...state,
        isLoading: false,
        v4Data: null,
      };

    default:
      return state;
  }
};
